import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import {  handleReportsToken} from '../../../constant/utils';
import { config } from '../../../constant';

const SmsConfig = () => {

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const env = import.meta.env.VITE_APP_ENV;
    const location = useLocation();
    const navigate = useNavigate();
   
    console.log('location?.state', location?.state)
    const encryptedToken = handleReportsToken();
    const sourceUrl: string = `${config().CAMPAIGN_URL}/cvmsmsconfig?cvm_data=${encryptedToken}`;
    // const sourceUrl: string = `https://2a20ab9f5cb6.ngrok-free.app/cvmsmsconfig?cvm_data=${encryptedToken}`;
    console.log('sourceUrl>>>>',sourceUrl)


  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.data?.type === 'CVM_IFRAME') {
        console.log('Received from iframe:', event.data);

        if (event?.data?.message?.navigate) {
         
            window.location.href ="https://myaccount.worktual.co.uk/number-management"
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
    
    return (

            <iframe
                id="smsCampaignFrame"
                ref={iframeRef}
                src={sourceUrl}
                style={{ width: "100%", height: "100%", border: 'none' }}
            />

        
    )
}

export default SmsConfig
